import { useCallback, useEffect, useState } from "react";

// auth provider
import { AWSCognitoProvider as AuthProvider } from "./contexts/aws-cognito-context";
import { FullscreenProvider } from "./contexts/fullscreen-context";
import NavigationScroll from "./layout/navigation-scroll";
// routing
import Routes from "./routes";
import { ThemeProvider } from "./themes/theme-provider";

import ErrorBoundary from "./components/ErrorBoundary";
// import { lockOrientation } from './utils/format-helper';

// ==============================|| APP ||============================== //

const App = () => {
  const [mode, setMode] = useState<"light" | "dark">(() => {
    const savedMode = localStorage.getItem("themeMode");
    return (savedMode as "light" | "dark") || "light";
  });

  // 1. Save mode to localStorage
  // 2. VITAL FOR TAILWIND/SHADCN: Add 'dark' class to html tag
  useEffect(() => {
    localStorage.setItem("themeMode", mode);

    const root = window.document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(mode);
  }, [mode]);

  // Use useCallback to memoize the toggle function
  const toggleMode = useCallback(() => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  }, []);

  return (
    <ErrorBoundary>
      <ThemeProvider mode={mode} toggleMode={toggleMode}>
        <NavigationScroll>
          <AuthProvider>
            <FullscreenProvider>
              <Routes />
            </FullscreenProvider>
          </AuthProvider>
        </NavigationScroll>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
